const conversationActionPermissionMatrix = {
    close: {
        isUnassigned: {
            currentUserIsOwner: {
                currentUserIsAdmin: false,
                currentUserIsBasic: false,
            },
            currentUserIsNotOwner: {
                currentUserIsAdmin: true,
                currentUserIsBasic: false,
            },
        },
        isAssigned: {
            currentUserIsOwner: {
                currentUserIsAdmin: true,
                currentUserIsBasic: true,
            },
            currentUserIsNotOwner: {
                currentUserIsAdmin: true,
                currentUserIsBasic: false,
            },
        },
    },
    assign: {
        isUnassigned: {
            currentUserIsOwner: {
                currentUserIsAdmin: false,
                currentUserIsBasic: false,
            },
            currentUserIsNotOwner: {
                currentUserIsAdmin: true,
                currentUserIsBasic: true,
            },
        },
        isAssigned: {
            currentUserIsOwner: {
                currentUserIsAdmin: false,
                currentUserIsBasic: false,
            },
            currentUserIsNotOwner: {
                currentUserIsAdmin: false,
                currentUserIsBasic: false,
            },
        },
    },
    unassign: {
        isUnassigned: {
            currentUserIsOwner: {
                currentUserIsAdmin: false,
                currentUserIsBasic: false,
            },
            currentUserIsNotOwner: {
                currentUserIsAdmin: false,
                currentUserIsBasic: false,
            },
        },
        isAssigned: {
            currentUserIsOwner: {
                currentUserIsAdmin: true,
                currentUserIsBasic: true,
            },
            currentUserIsNotOwner: {
                currentUserIsAdmin: true,
                currentUserIsBasic: false,
            },
        },
    },
    changeGroup: {
        isUnassigned: {
            currentUserIsOwner: {
                currentUserIsAdmin: false,
                currentUserIsBasic: false,
            },
            currentUserIsNotOwner: {
                currentUserIsAdmin: true,
                currentUserIsBasic: true,
            },
        },
        isAssigned: {
            currentUserIsOwner: {
                currentUserIsAdmin: false,
                currentUserIsBasic: false,
            },
            currentUserIsNotOwner: {
                currentUserIsAdmin: false,
                currentUserIsBasic: false,
            },
        },
    },
    changeOwner: {
        isUnassigned: {
            currentUserIsOwner: {
                currentUserIsAdmin: false,
                currentUserIsBasic: false,
            },
            currentUserIsNotOwner: {
                currentUserIsAdmin: true,
                currentUserIsBasic: false,
            },
        },
        isAssigned: {
            currentUserIsOwner: {
                currentUserIsAdmin: true,
                currentUserIsBasic: true,
            },
            currentUserIsNotOwner: {
                currentUserIsAdmin: true,
                currentUserIsBasic: false,
            },
        },
    },
    markRead: {
        isUnassigned: {
            currentUserIsOwner: {
                currentUserIsAdmin: false,
                currentUserIsBasic: false,
            },
            currentUserIsNotOwner: {
                currentUserIsAdmin: false,
                currentUserIsBasic: false,
            },
        },
        isAssigned: {
            currentUserIsOwner: {
                currentUserIsAdmin: true,
                currentUserIsBasic: true,
            },
            currentUserIsNotOwner: {
                currentUserIsAdmin: true,
                currentUserIsBasic: false,
            },
        },
    },
    markUnread: {
        isUnassigned: {
            currentUserIsOwner: {
                currentUserIsAdmin: false,
                currentUserIsBasic: false,
            },
            currentUserIsNotOwner: {
                currentUserIsAdmin: false,
                currentUserIsBasic: false,
            },
        },
        isAssigned: {
            currentUserIsOwner: {
                currentUserIsAdmin: true,
                currentUserIsBasic: true,
            },
            currentUserIsNotOwner: {
                currentUserIsAdmin: true,
                currentUserIsBasic: false,
            },
        },
    },
};

export { conversationActionPermissionMatrix };
